module.exports = __webpack_public_path__ + "img/user.b3f580af.png";